import { Component, OnInit } from '@angular/core';
import { MapDataService } from '../components/services/map-data.service';
import { Router} from '@angular/router';
import { AuthService } from 'src/app/user/services/auth.service';
import { UserSessionService } from '../services/usersession.services';
import jwt from 'jsonwebtoken';


//dailogs 
import { MatDialog } from '@angular/material/dialog';
import {FileExportComponent} from '../components/file-import/file-export.component';
import {FileDataService} from 'src/app/dashboard/components/services/file-data.service';
import {AuditTrailComponent} from '../audit-trail/audit-trail.component';
import {AddUserComponent} from '../add-user/add-user.component';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { DatePipe } from "@angular/common";


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  coordinates ={
    latitude : 50.78947908893568,
    longitude : 6.1122613284635054
  }

  profileId;
  intervalID;
  currentUser:any;

  constructor(private router: Router,
    private confirmDialog: MatDialog,
    private mapService:MapDataService,
    private fileService:FileDataService,
    private exportDialog : MatDialog,
    private auditDialog : MatDialog,
    private addUserDialog : MatDialog,
    private authService: AuthService,
    private datePipe: DatePipe,
    private userSessionService: UserSessionService ) {
      this.getCurrentLocation();  
  }

  ngOnInit(): void {
    this.getAllLoginUsers();    
    //this.intervalID = setInterval(this.verifyTokenExpiryTest2, 10000, "Parameter 1");  //240000
    this.intervalID = setInterval(() => this.sessionExtension(), 20000);
  } 

  sessionExtension() {
    let message: string;
    let width: string;

    const arrTokenVals = [];
    const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
    let token = storedUser.token;
    let decodedJWT = JSON.parse(window.atob(token.split('.')[1]));

    const tokenValues = decodedJWT.sub.toString();
    const arrFirstName = tokenValues.split(',')[0];
    const arrMiddleName = tokenValues.split(',')[1];
    const arrLastName = tokenValues.split(',')[2];
    const arrProfileName = tokenValues.split(',')[3];
    const arrUserId = decodedJWT.jti;
    const arrEmail = decodedJWT.email;
    const arrExp =decodedJWT.exp.toString();
    const arrIat = decodedJWT.iat;

    arrTokenVals.push(arrFirstName);
    arrTokenVals.push(arrMiddleName);
    arrTokenVals.push(arrLastName);
    arrTokenVals.push(arrProfileName);
    arrTokenVals.push(arrUserId);
    arrTokenVals.push(arrEmail);
    arrTokenVals.push(arrExp);
    arrTokenVals.push(arrIat);

    const expirationDatetimeInSeconds = decodedJWT.exp * 1000; 

    var curDateTime = new Date();
    // d = Mon Feb 29 2016 08:00:09 GMT+0100 (W. Europe Standard Time)

    var expiryDateTime = new Date(expirationDatetimeInSeconds);
    // d = Mon Feb 29 2016 08:00:09 GMT+0100 (W. Europe Standard Time)

    var milliSecondsVal = Date.parse(expiryDateTime.toString());
    // 1456729209000
    milliSecondsVal = milliSecondsVal - (5 * 60 * 1000);
    // - 5 minutes
    expiryDateTime = new Date(milliSecondsVal);

    if(curDateTime >= expiryDateTime) {  
      message = "Session will expire in 5 minutes. Do you want to extend the session ?";
        const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
        width,
        data: message,
        disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.saveData) {    
       this.fileService.extendSessionTimeOut(arrTokenVals).subscribe((data:any)=> {
        if (data != null) {
          const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
          var userId = storedUser.userId
          var token = data.responseToken.token
          var maxSession = data.responseToken.maxSession
          var current = storedUser.current - 1; // TODO

          this.currentUser ={
            arrUserId,
            token,
            maxSession,
            current
          };
        sessionStorage.setItem('currentUser',JSON.stringify(this.currentUser));
      } 
    },
          (err) => console.log("Error while get token expiry date: ", err)
        ); 
      } else {
        // do nothing
        clearInterval(this.intervalID);
      }
    })
    //clearInterval(this.intervalID);
  }
  } 

  verifyTokenExpiryTest2(): void {
    let message: string;
    let width: string;
   
    message = "Session will expire in 5 minutes. Do you want to extend the session ?";
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
    width,
    data: message,
    disableClose: false
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.saveData) {    
      
      }
    })
  }

  verifyTokenExpiryTest(expiryValue) {
   let message: string;
   let width: string;
  
   message = "Session will expire in 5 minutes. Do you want to extend the session ?";
   width = "28rem";
   
   const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
     width,
     data: message,
     disableClose: false
   });
   dialogRef.afterClosed().subscribe(result => {
     if (result.saveData) {  
       //console.log("save data", result.saveData);    
     } else {
       // do nothing
     }
   })

  }

  verifyTokenExpiry(expiryValue) {
    const arrTokenVals = [];
    const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
    let token = storedUser.token;
    let decodedJWT = JSON.parse(window.atob(token.split('.')[1]));

    const tokenValues = decodedJWT.sub.toString();
    const arrFirstName = tokenValues.split(',')[0];
    const arrMiddleName = tokenValues.split(',')[1];
    const arrLastName = tokenValues.split(',')[2];
    const arrProfileName = tokenValues.split(',')[3];
    const arrUserId = decodedJWT.jti;
    const arrEmail = decodedJWT.email;
    const arrExp =decodedJWT.exp;
    const arrIat = decodedJWT.iat;

    arrTokenVals.push(arrFirstName);
    arrTokenVals.push(arrMiddleName);
    arrTokenVals.push(arrLastName);
    arrTokenVals.push(arrProfileName);
    arrTokenVals.push(arrUserId);
    arrTokenVals.push(arrEmail);
    arrTokenVals.push(arrExp);
    arrTokenVals.push(arrIat);

    const expirationDatetimeInSeconds = decodedJWT.exp * 1000;

    clearInterval(this.intervalID);
    let message: string;
    let width: string;
  
    message = "Session will expire in 5 minutes. Do you want to extend the session ?";
    width = "28rem";
    
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
      width,
      data: message,
      disableClose: false
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.saveData) {  
        //console.log("save data", result.saveData);
        //force logout
        //generate new token
        this.fileService.extendSessionTimeOut(arrTokenVals).subscribe((data:any)=> {
          if (data != null) {
          } 
          },
            (err) => console.log("Error while get token expiry date: ", err)
          ); 
        // update this token in local storage
        // and next communication happens with this new token      
      } else {
        // do nothing
      }
    })
  }
  
  getAllLoginUsers(){
    //check for valid session count
    const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
    var maxSession = storedUser.maxSession
    var current = storedUser.current

    if(current < maxSession) {    
      this.fileService.getLoginUsers().subscribe((data:any)=> {
      if (data.responseStatus === "Success") {
          var email=data.responseData;
          const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
          var userid=storedUser.userId
          var currentUserName=email.responseData.filter(b => b.userId==userid)[0]    
          this.fileService.currentUserName=currentUserName;
          this.profileId = currentUserName.id_profile;
      } else if (data.responseCode != null && data.responseCode.statusCode === 401) {
          this.authService.logout();
          this.router.navigate(['/user/login']);
        }
      },
        (err) => console.log("Error while get all users: ", err)
      ); 
    } else {
        this.userSessionService.cancelThisSession().subscribe((res:any) => { });
        this.authService.logout();            
        this.router.navigate(['/user/login']);
      }
  }

  openExportDialog():void{
    this.exportDialog.open(FileExportComponent, {
      width: '30rem',
      disableClose :false,
    });
  }

 getCurrentLocation() {
  this.mapService.getInitialMapCoordinates().subscribe(
    (res:any) => {
      const {latitude, longitude} = res;
      this.coordinates =  {latitude, longitude};
    },
    err => console.log(err)
  )
 }
 openAuditTrail():void{
  this.auditDialog.open(AuditTrailComponent, {
    width: '100rem',
    disableClose :false,
  });
} 
openAddUser():void{
  this.addUserDialog.open(AddUserComponent, {
    width: '100rem',
    disableClose :false,
  });
} 
}

